import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'showPrintFromDisk',
    standalone: false
})
export class ShowPrintFromDiskPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(file: File, ...args: unknown[]): unknown {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(file)
    );
  }
}
